/**
 * @fileoverview GET handler for the "/apps/business/business_sources" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessSources } from "./constants";
import type { AppsBusinessSourcesResult } from "./types";
import { isAppsBusinessSourcesResult } from "./validators";

export const getAppsBusinessSources = reactQueryFetcherAdapter(
  appsBusinessSources,
  (signal: AbortSignal): Promise<AppsBusinessSourcesResult> => {
    return fetch("/apps/business/business_sources", "GET", {}, { signal });
  },
  isAppsBusinessSourcesResult
);
